import React, { lazy } from 'react';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/gefqiS4WRLhHw7jN9xb8XS/2_7ec09eea-8db7-401c-b3cf-4c38a57d2468.webp',
  title: 'Pan Rústico Artesanal',
  description: 'Corteza dorada y miga aireada, como el de panadería artesanal. Sin gluten.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5fJb4FEA16hLmNnGQt7H69/4_80e8705e-bbe6-4e8b-b55a-b71c581742c4.webp',
  title: 'Focaccia con Hierbas',
  description: 'Esponjosa, con romero y aceite de oliva. Perfecta para acompañar cualquier comida. Sin gluten.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/fFH7d8qCYNub5DL5LeMooD/3_d9ef347f-2bd3-48a1-83c9-721a8c44aef0.webp',
  title: 'Pan de Molde Suave',
  description: 'Ideal para sándwiches y tostadas. Textura tierna que no se desmigaja. Sin gluten.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/w4uZH1GAVkqVKURaLmqgCr/5_6c5a0c76-f3fc-42a4-a1c7-9b976ac0c7ce.webp',
  title: 'Bollería Casera',
  description: 'Bollos tiernos y dorados, perfectos para el desayuno o la merienda. Sin gluten.'
}];
export function ImageCarousel() {
  return <section className="py-8 md:py-12 bg-white overflow-hidden pt-[0px] pb-[0px]" data-id="element-156">
      <div className="flex w-max group" style={{
      animation: 'carousel-scroll 35s linear infinite'
    }} onMouseEnter={e => {
      ;
      (e.currentTarget as HTMLDivElement).style.animationPlayState = 'paused';
    }} onMouseLeave={e => {
      ;
      (e.currentTarget as HTMLDivElement).style.animationPlayState = 'running';
    }} data-id="element-157">
        {/* Duplicate images 3x for seamless infinite loop */}
        {[...images, ...images, ...images].map((item, index) => <div key={index} className="flex-shrink-0 px-2 md:px-3" data-id="element-158">
            <img src={item.src} alt={item.title} className="w-64 h-64 md:w-72 md:h-72 object-cover rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.08)]" loading="lazy" data-id="element-159" />
            <div className="mt-2 px-1 w-64 md:w-72" data-id="element-160">
              <p className="font-bold text-gray-900 text-sm md:text-base leading-tight" data-id="element-161">
                {item.title}
              </p>
              <p className="text-gray-500 text-xs md:text-sm mt-0.5 leading-snug" data-id="element-162">
                {item.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}